import React from 'react';

const Button = ({color, size, className, children, disabled, onClick, ariaLabel}) => {

    const BUTTON_COLOR = {
        PRIMARY: 'hover:bg-yellow-600 hover:text-white active:bg-gray-100 bg-yellow-500 text-white rounded-md',
        PRIMARYFIXE:'bg-yellow-500 text-white rounded-md sh-sm ',
        SECONDARY: 'hover:bg-gray-100 hover:text-gray-700 active:bg-gray-200 bg-white text-gray-700 border b-white rounded-md border-gray-100',
        DEFAULT: 'hover:bg-gray-50 hover:text-gray-700 hover:border-gray-200 active:bg-gray-100 bg-transparent text-gray-700 border border-transparent rounded',
        DISABLED: 'bg-gray-50 text-gray-400 border-0 b-gray-300 rounded-md sh-sm',
        BLUE: 'bg-blue-600 text-white rounded-md sh-sm hover:text-white active:bg-blue-100',
        TABLE: 'bg-transparent text-gray-700 hover:bg-gray-100 active:bg-gray-200 rounded cursor-pointer',
    }

    const BUTTON_SIZE = {
        SM: 'text-sm py-2 px-4',
        SMI: 'text-sm p-2',
        LG: 'h-12 text-base py-3 px-4',
        LGI: 'text-sm p-3',
        FULL: 'w-full text-lg py-3 px-6',
        ICON: 'h-9 w-9',
        XS: 'text-xs p-1',
        TABLE: 'w-9 h-9 flex items-center justify-center',
    }
    const colorClassName = BUTTON_COLOR[color || 'PRIMARY']
    const sizeClassName = BUTTON_SIZE[size || 'SM']

    return (
        <button type={'button'}
                className={'flex flex-row justify-center items-center gap-2 ' + sizeClassName + ' ' + colorClassName + ' ' + (className || '')}
                disabled={disabled} onClick={onClick}
                aria-label={ariaLabel}
        >
            {children}
        </button>
    );
};

export default Button;